// #region Imports
import { Theme } from '@radix-ui/themes';
import type { AZThemeProps } from './AZTheme.types';
// #endregion

// #region Component
/**
 * AZmed theme provider. Wrap your application with this component once at the root.
 * Applies Oxford Blue (#000f34) as primary and Xanthus (#ffbc42) as accent.
 *
 * Consumers must import Radix Themes styles separately:
 *   import '@radix-ui/themes/styles.css';
 *   import '@azmed-org/ui/styles';
 *
 * @example
 * <AZTheme>
 *   <App />
 * </AZTheme>
 *
 * @example Override theme
 * <AZTheme appearance="dark" accentColor="violet">
 *   <App />
 * </AZTheme>
 */
const AZTheme = ({
  children,
  accentColor = 'amber',
  grayColor = 'slate',
  radius = 'medium',
  appearance = 'inherit',
  ...props
}: AZThemeProps) => (
  <Theme
    accentColor={accentColor}
    grayColor={grayColor}
    radius={radius}
    appearance={appearance}
    {...props}
  >
    {children}
  </Theme>
);
// #endregion

// #region Display Name
AZTheme.displayName = 'AZTheme';
// #endregion

export { AZTheme };
